import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';

export default class FormInput extends React.Component {
	
	constructor(props) {
		
		super(props);
		
		this.state = {
			errorRegexp: props.errorRegexp,
			disabled: false
		};
		
		this.handleChange = this.handleChange.bind(this);
	}
	
	handleChange(e) {
		
		var { disabled, errorRegexp } = this.state;
		
		const { typeError, handleValue } = this.props;
		
		if (disabled)
		{
			return false;
		}
		
		const value = e.target.value;
		
		handleValue(e, value);
		
		if (value.length != value.replace(errorRegexp, '').length)
		{
			typeError(e, true);
		}
		else
		{
			typeError(e, false);
		}
	}
	
	render() {
		
		const { disabled } = this.state;
		
		const { handleChange } = this;
		
		const { error, tabIndex, icon, placeholder, type, name } = this.props;
		
		return (
			<Form.Input
				disabled={disabled}
				error={error}
				onChange={handleChange}
				tabIndex={tabIndex}
				fluid
				name={name}
				icon={icon}
				iconPosition="left"
				placeholder={placeholder}
				type={type ? "password" : "text"}
			/>
		);
	}
}